/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/input-box/input-box');
require('components/base/checkbox/checkbox');
require('components/base/form-area/form-area');
require('components/base/drop-menu/drop-menu');
require('components/base/upload/upload')
require('components/common/drop-menu-input/drop-menu-input')

require('components/common/table-data/table-data');
const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent } = require('components/config/event.json');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');

const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const { setTopicInfoImgs } = require('appVuex/action/topicInfoImgs');
const Sortable = require('./Sortable.min.js');

const detailsComponents = require('../detailsComponents/detailsComponents');


const template = require('./detailsTopic-add.tpl');
require('./detailsTopic-add.scss');

const detailsTopic = {
	template,
	store,
	vuex: {
		actions: {
			setTopicInfoImgs,
		}
	},

	data() {
		return {
			url: apiPath.community.addDetails,
			editUrl:apiPath.community.editDetails,
			uploadImg: apiPath.common.uploadImg,
			upTopicsContent:apiPath.community.editTopicsContent,
			searhcContent:apiPath.community.searhcTopicContent,
			componentsList:[
				/*{indet:'a0', text:''}*/
			],
			controlList:[],
			controlItmes:[
				{type:"section", text:"段落"},
				{type:"text", text:"正文文本"},
				{type:"image", text:"图片"},
				{type:"annotation", text:"注释文本"},
				{type:"video", text:"视频"},
				{type:"url", text:"跳转链接"},
				{type:"vote", text:"投票"}
			],
			itemsObj:{
				"section":"段落",
				"text":"正文文本",
				"image":"图片",
				"annotation":"注释文本",
				"video":"视频",
				"url":"跳转链接",
				"plug":"充电点",
				"vote":"投票"
			},
			detailData:{
				controls:[]
			},
			controlls:[],
			"showControl":false,
			deleIdx:0,
			deleMessage:"确定删除吗?",
			bannerImgs:JSON.parse(localStorage.getItem('bannerImgs')) || {},
			domain:window.location.hostname+(window.location.port? ':'+window.location.port:""),
			detailsId:this.$route.params.id || '',
			dragSortS:0,
			dragSortE:0,
			sortTable:"",
			fromLogin:false
			
		}
	},
	ready(){

		$("body").addClass("hideSide");
		this._init();
		
	},
/*	computed:{
		controlList(){

		}
	},*/
	route:{
		data(transition){

			if(typeof transition.from.name=='undefined' || transition.from.name=='login'){
				this.fromLogin = true;
			}else{
			sessionStorage.setItem('jumpBackUrl',transition.from.path);
			}
			//console.log(transition.from.path);
			
		}
	},
	methods:{
		_init(){

			if(this.fromLogin){
				this.parseData(1);
				return;
			}
			if(this.$route.params.id) {
        // 编辑状态
        ajaxHttp(this.searhcContent,{
          data:{
            id:this.$route.params.id
            }
          })
          .then((rtn) => {
            let data =rtn.data;
            let that =this;
            

            //that.bannerImgs[data.banner] = {url:data.bannerUrl,id:data.banner};
            let _bannerObj = {};
            	_bannerObj[data.banner] = {url:data.bannerUrl,id:data.banner};
            data.controls.forEach((item,idx) => {
            	if(item.type=="image"){
            		_bannerObj[item.image] = {
            				url:item.imageUrl,
            				id:item.image
            			};
            	}
            })
            that.bannerImgs = _bannerObj;
            

            that.detailData = data;
            that.controlls = data.controls;
            that.controlList = that.formatControItems(that.controlls);
 
            that.$nextTick(function(){
            	that.setTopicInfoImgs(that.bannerImgs);
							that.sortlist();
						});

            }).catch((rtn) => {
              tip(rtn.message)
          })
      }
		},
		jumpBack(){
			if(this.fromLogin){
				let _jumUrl = sessionStorage.getItem('jumpBackUrl') || '/page/server/official-list';
				this.$router.go({
            path: _jumUrl
          });
				return;
			}
			window.history.back();

		},
		sortlist(){
			let that = this;

			that.sortTable && that.sortTable.destroy();

			var el = document.getElementById('sortlist');
			that.sortTable = new Sortable(el, {
				onStart:function(evt){
					var $itemEl = $(evt.item);
					that.dragSortS = $itemEl.index();
				},
				onEnd: function (evt) {
					var $itemEl = $(evt.item);
					that.dragSortE = $itemEl.index();
					console.log('s='+that.dragSortS+'&e='+that.dragSortE);

					if(that.dragSortS == that.dragSortE){
						return;
					}

					that.detailData = that.formatDatas();
					that.controlls =  that.formatDatas().controls;

					that.controlList = that.placeArray(that.controlList,that.dragSortS, that.dragSortE);
					that.controlls = that.placeArray(that.controlls,that.dragSortS, that.dragSortE);

					//that.detailData = Object.assign({},that.detailData);
					that.bannerImgs = Object.assign({},that.bannerImgs);
					that.$nextTick(function(){
						that.setTopicInfoImgs(that.bannerImgs);
					});
				}
			});
		},
		placeArray(arr,s,e){
			var _arr=arr.concat();
			var _tg = _arr.splice(s,1)[0];
			_arr.splice(e,0,_tg);
			return _arr;
		},
		formatControItems(col){

			let _ar =col;
			let _arr=[];
			_ar.forEach((item,idx) => {
				_arr.push({type: item.type,text:this.itemsObj[item.type]});
			})
			return _arr;

		},
		addControl(item){
			let _obj = Object.assign({},item);
			this.controlList.push(_obj);
			this.controlls.push({type: _obj.type});
			
			this.$nextTick(function(){
				this.sortlist();
			})
		},
		showDel(idx){
			this.deleIdx = idx;
			var _mess = this.controlList[idx].text;
			this.deleMessage = `确定删此${_mess}吗?`;
			this.$refs.popsdelete.show();
		},
		removeControl(){
			this.controlList.splice(this.deleIdx,1)
			this.controlls.splice(this.deleIdx,1);
			this.$refs.popsdelete.hide();

			this.$nextTick(function(){
				this.sortlist();
			})
		},
		cancel(){
			this.$refs.popsdelete.hide();
		},
		showDelPop() {
			this.$refs.popsdelete.show();
		},
		scrollFix(idx){
			var $tag = typeof idx =='string' ? $(idx) : $('.detailsComponets-wrap').eq(idx);
			$('html, body').stop();
			$('html, body').animate({
            scrollTop: $tag.offset().top-80
        }, 600);
			return false;
		},
		formatDatas(){
			this.$refs.baseform._initFormData();
			let _opt = this.$refs.baseform.queryOpt;
			console.log(_opt);
      let _colObj = this.formatArgs(_opt,'--','controls');
      var _colArr = _colObj['controls'];

      _colArr.forEach((item,idx) => {
      	if(item.type=='vote'){
      		_colObj['controls'][idx] = this.formatArgs(_colObj['controls'][idx],'&','option');
      	}
      });

      console.log(_colObj);
      return _colObj;


		},
		formatArgs(obj,accord,name){
			var _obj = {},
					colObj = {},
				 args = obj,
				 _arr = [],
				 _name =name || 'controls',
				 accord = accord || '--',
				 _k = "",
				 _n = "";
			
			for(var key in args){
				if(key.indexOf(accord)==-1){
					colObj[key] = args[key];
				}else{
				 _k =key.split(accord)[1], _n = key.split(accord)[0];
				_obj[_n] = args[key];
				
				_arr[_k] = _arr[_k] || {};
				Object.assign(_arr[_k],_obj);
				_obj={};
				}
			}
			colObj[_name] = _arr;
			return colObj;


		},
		copyData(it){
			if(this.controlls.length==0){
    		this.$refs.addcontrol.show();
    		return;
    	}
			let _detailsData = this.formatDatas();
			localStorage.setItem("copyDetailsData", JSON.stringify(_detailsData));
			localStorage.setItem("controlList",JSON.stringify({'controlList':this.controlList}))
			localStorage.setItem("bannerImgs",JSON.stringify(this.bannerImgs)); 

			console.log(JSON.stringify(_detailsData));
			console.log(JSON.stringify(this.bannerImgs));

			if(it==1){return;}
			tip("拷贝数据成功");
		},
		parseData(it){
			let _data = localStorage.getItem("copyDetailsData");
			if(_data===null){
					tip("您还没有拷贝数据");
					return;
			}



			let _imgData = localStorage.getItem('bannerImgs')||"";


			let detailsData = JSON.parse(_data);
			this.bannerImgs = JSON.parse(_imgData);
			this.detailData = detailsData;
			this.controlls = detailsData.controls;
			this.controlList = JSON.parse(localStorage.getItem("controlList")).controlList;
			this.$nextTick(function(){
				this.setTopicInfoImgs(this.bannerImgs);
			});
			this.sortlist();
			
			localStorage.removeItem("copyDetailsData");
			localStorage.removeItem("controlList");
			localStorage.removeItem("bannerImgs"); 
			if(it==1){return;}
			tip("粘贴数据成功");

		},
		uploadSuccess(obj,ot){
			this.bannerImgs[obj.data.picId] = {url:obj.data.picPath,id:obj.data.picId};

		},
		beforeSubmit(queryOpt, vm) {

      vm.queryOpt = this.formatDatas();

    },
    loginLose(){
    			let that = this;
          tip('登录信息过期');
          window.localStorage.removeItem('appBackToken');
          AB.TOKEN = null;

           let _hash = window.location.hash,
            _idx =_hash.indexOf("/");
            _hash = _hash.substring(_idx);
            if(_hash!="/login" && _hash.indexOf('/page') !=-1){
              sessionStorage.setItem("cbkURL",_hash);
            }

          
          setTimeout(()=>{
            that.$route.router.go({
              path: '/login'
            });
          }, 1000);
    },
    submitSuccess (rtn) {
    	if(rtn.code==2){
    		this.copyData(1);
    		this.loginLose();
    		return;
    	}
      if (rtn.code === 0) {
        tip ('保存成功');
        this.detailsId = rtn.data.id;

        let _topicRequireOpt =sessionStorage.getItem('topicRequireOpt');
        if(!_topicRequireOpt || this.$route.params.id){
        	return;
        }
        let _jsonOpt = JSON.parse(_topicRequireOpt);
        if(!_jsonOpt.topicInfo){
        	_jsonOpt['topicInfo'] = 'http://'+this.domain+'/#!/preview/'+rtn.data.id;
        }
        sessionStorage.setItem('topicRequireOpt',JSON.stringify(_jsonOpt));
      }else{
      	tip(rtn.error || '系统繁忙,请稍候在试');
      }
     
    },

    submit() {
    	if(this.controlls.length==0){
    		this.$refs.addcontrol.show();
    		return;
    	}
      let url = this.detailsId? this.editUrl : this.url;
      this.$refs.baseform.setAction(url).submit();
    },
    jumpPrivew(e){

    	let that = this;
    	if(that.controlls.length==0){
    		that.$refs.addcontrol.show();
    		return;
    	}

    	//保存临时预览数据
    	let _previw = that.formatDatas();
    	_previw['bannerUrl'] = that.bannerImgs[_previw.banner].url;

    	let _modelList = _previw.controls;
    	_modelList.forEach((item,idx) => {
    		if(item.type=="image"){
    			item['imageUrl'] = that.bannerImgs[item['image']].url;
    		}
    	})

    	_previw['controls'] = _modelList;
    	localStorage.setItem("_peviewObj",JSON.stringify(_previw));
    	console.log(_previw);
    	let _href = 'http://'+this.domain+'/#!/preview/brevity/9999';
    	$(e.target).attr('href',_href);
    }


	},
	components:{
		pop,
		detailsComponents
	},
	destroyed:function (argument) {
		$("body").removeClass("hideSide");
	}
}

module.exports = detailsTopic;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/details-topic/detailsTopic-add/detailsTopic-add.js